/*Edit thong tin ve nguon tin va tai nan, phuong tien bi nan */
import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Input from "@material-ui/core/Input";
import MaskedInput from "react-text-mask";
import PropTypes from "prop-types";
import SelectFilter from "react-select";
import Select from "@material-ui/core/Select";
import Checkbox from "@material-ui/core/Checkbox";
import CircularProgress from "@material-ui/core/CircularProgress";
import DateTimePicker from "react-datetime";
import MyLatLonEditor from "./LatLonEditor";

import {
  DatePicker,
  TimePicker,
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
} from "@material-ui/pickers";

import moment from "moment";

import MyButton from "../MyButton";

const myLib = require("../../lib/MyLib");
const server = require("../../lib/server");
const sukienLayer = require("../../lib/SuKienDataLayer");
///////////////////////////////////////////////////////////////////
const defaultRecord = {
  SuKienThat: true,
  TrangThai: "1", // dang xu ly
  KetThuc: null, //thoi gian ket thuc su vu
  KetQuaChung: "0",
  TimKiem: false,
  KQTimKiem: "0",
  CuuNan: false,
  KQCuuNan: "0",
};
class SuKienKetQuaControl extends React.Component {
  constructor(props) {
    super(props);
    this.saveField = this.saveField.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.state = {
      canSaved: false, //cho phep save hay khong
      dataChanged: false, //du lieu co su thay doi hay khong
      saving: false, //co dang save du lieu hay khong
      errorLog: "", //mo ta loi neu co
      //danh muc quoc gia
      loading_quoctich: true, // co dang loading danh muc quoc gia khong
      source_quoctich: [], //danh muc options cho quoc tich
      before:
        props.value === undefined
          ? {
              ThoiGian: new Date(),
            }
          : myLib.cloneObject(props.value), //thong tin truoc khi edit
      after:
        props.value === undefined
          ? defaultRecord
          : { ...defaultRecord, ...{...props.value, TrangThai: props.value.TrangThai === 0 ? 1 : props.value.TrangThai} }, //thong tin dang edit (neu draft thi chuyen trang thai thanh 1)
      validateStatus: {},
    };
  }
  //ghi nhan gia tri nhap
  saveField = (fieldName, value) => {
    var old_changed = this.state.dataChanged;
    var s = this.state;
    s.after[fieldName] = value;
    s.dataChanged = !myLib.isSame(s.before, s.after, [
      "SuKienThat",
      "TrangThai",
      "KetThuc",
      "KetQuaChung",
      "TimKiem",
      "KQTimKiem",
      "CuuNan",
      "KQCuuNan",
    ]);
    s.canSaved = s.dataChanged;
    console.log(s);
    if(this.props.onChanged && old_changed != s.dataChanged) {
      this.props.onChanged(s.dataChanged);
    }
    this.setState(s);
  };
  //submit thong tin ve DB
  handleSave = () => {
    console.log(JSON.stringify(this.state.after));
    var check = sukienLayer.validate("ketqua", this.state.after);
    if (!check.error) {
      this.setState({ validateStatus: check, saving: true, errorLog: "" });
      server
        .post(
          "sukien/saveKetQua",
          sukienLayer.chuanHoaSukien("ketqua", this.state.after)
        )
        .then((response) => {
          var before = {};
          var after = this.state.after;
          Object.assign(before, after);
          this.setState({
            before: before,
            after: after,
            dataChanged: false,
            canSaved: false,
            saving: false,
            errorLog: "",
          });
          //thong bao cho parent biet co data duoc saved
          if (this.props.onSaved) {
            this.props.onSaved(after);
          }
          if(this.props.onChanged) {
            this.props.onChanged(false);
          }
        })
        .catch((error) =>
          this.setState({ saving: false, errorLog: error + "" })
        );
    } else {
      this.setState({ validateStatus: check });
    }
  };
  loadDanhMuc() {
    //load danh muc tai nan
    server
      .query("quocgia/getall")
      .then((response) => {
        var list = [];
        response.map((item, index) =>
          list.push({ value: item.MaQG, label: item.TenQuocGia })
        );
        this.setState({ source_quoctich: list, loading_quoctich: false });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading_quoctich: false });
      });
  }
  //khi load component: load cac danh muc can thiet
  componentDidMount() {
    this.loadDanhMuc();
  }
  static getDerivedStateFromProps(props, state) {
    var newState = { ...state };
    //console.log("TaiNanControl props:", props.value);
    if (props.value !== undefined && props.value.MaSK !== state.after.MaSK) {
      //console.log("co su thay doi");
      //co su thay doi
      newState = {
        ...newState,
        after: { ...state.after, ...props.value },
      }; //lay thong tin tu parent form truyen vao thong qua props
    }
    //console.log("TaiNanControl new state:", newState);
    return newState;
  }
  render() {
    const { classes, theme } = this.props;
    return (
      <Accordion disabled={this.props.disabled} 
      defaultExpanded={this.props.value !== undefined}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          classes={{
            root: classes.normalPanel,
            expanded: classes.expandedPanel,
            content: classes.summaryContent
          }}
        >
          <Typography className={classes.heading}>Kết quả</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <FormControl className={classes.formControl}>
                <InputLabel id="demo-simple-select-label">
                  Trạng thái(*):
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  className={classes.textbox}
                  autoWidth={true}
                  labelWidth={100}
                  value={this.state.after.TrangThai}
                  onChange={(event) =>
                    this.saveField("TrangThai", event.target.value)
                  }
                >
                  <MenuItem value={"1"}>Đang xử lý</MenuItem>
                  <MenuItem value={"2"}>Kết thúc</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3}>
              <InputLabel
                id="labelTungay"
                className={
                  this.state.validateStatus.KetThuc !== undefined
                    ? classes.labelError
                    : classes.label
                }
              >
                Kết thúc:
              </InputLabel>
              <DateTimePicker
                id="txtKetThuc"
                dateFormat="DD/MM/YYYY"
                timeFormat="HH:mm"
                closeOnSelect={true}
                value={this.state.after.KetThuc}
                inputProps={{
                  maxLength: 100,
                  onBlur: (event) => {
                    var text = event.target.value;
                    if(this.state.after.KetThuc === null && text != '') {
                      var date = myLib.tryToDate(text);
                      if(date) {
                        this.saveField('KetThuc', date);
                      }
                    }
                  }
                }}
                onChange={(date) => {
                  this.saveField("KetThuc", date && date.toDate ? date.toDate() : null);
                }
                }
              />
            </Grid>
            <Grid item xs={3}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.after.SuKienThat}
                    onChange={(event) =>
                      this.saveField("SuKienThat", event.target.checked)
                    }
                    name="chkSuKienThat"
                  />
                }
                label="Sự kiện thật"
              />
            </Grid>
            <Grid item xs={3}>
              <FormControl className={classes.formControl}>
                <InputLabel id="demo-simple-select-label">
                  Kết quả chung:
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  className={classes.textbox}
                  autoWidth={true}
                  labelWidth={100}
                  value={this.state.after.KetQuaChung}
                  onChange={(event) =>
                    this.saveField("KetQuaChung", event.target.value)
                  }
                >
                  <MenuItem value={"0"}>Không có KQ</MenuItem>
                  <MenuItem value={"1"}>Kết quả một phần</MenuItem>
                  <MenuItem value={"2"}>Có kết quả</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            
            <Grid item xs={3}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.after.TimKiem}
                    onChange={(event) =>
                      this.saveField("TimKiem", event.target.checked)
                    }
                    name="chkTimKiem"
                  />
                }
                label="Có tìm kiếm"
              />
            </Grid>
            <Grid item xs={3}>
              <FormControl className={classes.formControl}>
                <InputLabel id="demo-simple-select-label">
                  Kết quả:
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  className={classes.textbox}
                  autoWidth={true}
                  labelWidth={100}
                  value={this.state.after.KQTimKiem}
                  onChange={(event) =>
                    this.saveField("KQTimKiem", event.target.value)
                  }
                >
                  <MenuItem value={"0"}>Không có KQ</MenuItem>
                  <MenuItem value={"1"}>Kết quả một phần</MenuItem>
                  <MenuItem value={"2"}>Có kết quả</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.after.CuuNan}
                    onChange={(event) =>
                      this.saveField("CuuNan", event.target.checked)
                    }
                    name="chkCuuNan"
                  />
                }
                label="Có cứu nạn"
              />
            </Grid>
            <Grid item xs={3}>
              <FormControl className={classes.formControl}>
                <InputLabel id="demo-simple-select-label">
                  Kết quả:
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  className={classes.textbox}
                  autoWidth={true}
                  labelWidth={100}
                  value={this.state.after.KQCuuNan}
                  onChange={(event) =>
                    this.saveField("KQCuuNan", event.target.value)
                  }
                >
                  <MenuItem value={"0"}>Không có KQ</MenuItem>
                  <MenuItem value={"1"}>Kết quả một phần</MenuItem>
                  <MenuItem value={"2"}>Có kết quả</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3}>
              {this.state.canSaved ? (
                <MyButton
                  onClick={this.handleSave}
                  color="primary"
                  text="Lưu"
                />
              ) : null}
            </Grid>
            <Grid item xs={3}>
              {this.state.saving ? (
                <CircularProgress />
              ) : this.state.errorLog === "" ? null : (
                this.state.errorLog
              )}
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    );
  }
}
const styles = (theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
    heigh: "fit-content",
  },
  formControl: {
    marginTop: 2,
    minWidth: 120,
  },
  label: {
    margin: 6,
  },
  labelError: {
    margin: 6,
    color: "red",
  },

  thoigian: {
    marginLeft: 1,
    marginRight: 1,
    width: 200,
  },
  textbox: {
    marginLeft: 1,
    marginRight: 1,
    width: "100%",
  },
  uppercaseText: {
    textTransform: "uppercase",
  },
  normalPanel: {
    backgroundColor: "lightskyblue",
    margin: 0,
    minHeight: 11,
  },
  expandedPanel: {
    backgroundColor: "skyblue",
    margin: 0,
    minHeight: '10px !important',
  },
  summaryContent: {
    margin: '1px !important',
  },
});
export default withStyles(styles, { withTheme: true })(SuKienKetQuaControl);
